import { Stack } from '@mui/material'
import React from 'react'

/**
 * TEMP LOCAL ONLY: set to true to see the next-year box outside December.
 * Must be false when committing.
 */
const FORCE_NEXT_YEAR_FOR_LOCAL_TESTING = true

/** Next year's targets are prepared in December. */
export const isNextYearPlanningPeriod = (now: Date = new Date()): boolean =>
  FORCE_NEXT_YEAR_FOR_LOCAL_TESTING || now.getMonth() === 11

export interface YearTargetsSectionProps {
  /** Editor for the current year. */
  currentYear: React.ReactNode
  /** Editor for next year. */
  nextYear: React.ReactNode
}

/**
 * Current-year and next-year target editors, shared by ilarit and incentive sales.
 *
 * In December the next-year box is shown on top of the current year for everyone. Whether a
 * manager can actually edit it is decided inside the editor: until the SOK admin has set the
 * yearly target, managers see a "not set yet" message instead of the edit button.
 */
export function YearTargetsSection({ currentYear, nextYear }: YearTargetsSectionProps) {
  return (
    <Stack direction='column' spacing={2} mb={2}>
      {isNextYearPlanningPeriod() && nextYear}
      {currentYear}
    </Stack>
  )
}
